// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IFirmwareErrorStat {
	firmwareVersion: string | undefined;

	totalErrorCount: number;

	uniqueErrorTypes: number;

	deviceCount: number;

	$type?: string | undefined;
}
export class FirmwareErrorStat {
	constructor(data?: IFirmwareErrorStat) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	firmwareVersion: string | undefined;

	totalErrorCount: number = 0;

	uniqueErrorTypes: number = 0;

	deviceCount: number = 0;

	static $type: string = "CoreApi.Data.FirmwareErrorStat, ";
	$type?: string | undefined = FirmwareErrorStat.$type;
}

